// extracted by mini-css-extract-plugin
module.exports = {"msg-container":"Msg_msg-container__3oXGP","msg-content":"Msg_msg-content__1i9KY","image":"Msg_image__3L5tg","sender":"Msg_sender__30p4g","receiver":"Msg_receiver__1Otnw"};